import { useCallback, useState } from 'react';
import { COPY_TO_CLIPBOARD_RESET_DELAY_MS } from '@/constants/common';

interface UseCopyToClipboardOutput {
  copy: (text: string) => Promise<boolean>;
  isCopied: boolean;
}

function useCopyToClipboard(resetDelay = COPY_TO_CLIPBOARD_RESET_DELAY_MS): UseCopyToClipboardOutput {
  const [isCopied, setIsCopied] = useState(false);

  const copy = useCallback(
    async (text: string) => {
      try {
        await navigator.clipboard.writeText(text);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), resetDelay);
        return true;
      } catch {
        setIsCopied(false);
        return false;
      }
    },
    [resetDelay],
  );

  return { copy, isCopied };
}

export default useCopyToClipboard;
